import { render, staticRenderFns } from "./organize_details.vue?vue&type=template&id=d97b96b6&"
import script from "./organize_details.vue?vue&type=script&lang=js&"
export * from "./organize_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports